import React, { useState, useEffect } from "react";
import { Grid, IconButton, Paper } from "@material-ui/core";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Checkbox,
  TableBody,
  Typography,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
// import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../StyledComponents/Heading/Heading";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
import Stack from "@mui/material/Stack";

import LinearProgress from "@mui/material/LinearProgress";

const useStyles = makeStyles({
  table: {
    minWidth: 650,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  inputStyle: {
    outline: "none",
    border: "none",

    // borderBottom: "1px solid black",
    // backgroundColor: item?.selected && "rgb(240,240,240)",
    width: "100px",
  },
});

function PoImportReference_Table({
  setPOImportReference_Table,
  POImportReference_Table,
  loading,
  formState,
  setFormState,
  disabled
}) {
  const classes = useStyles();
  useEffect(() => {
    if (formState?.invoicePORef_List?.length > 0) {
      if (POImportReference_Table?.length === 0) {
        var _conditions = new Set(
          formState?.invoicePORef_List
            .map((i) => i.vText)
            .filter((i) => i != null && i != "")
        );
        var _condList = [];
        _conditions.forEach(function (item) {
          _condList.push({ Condition_vText: item, amount: 0.0 });
        });
        setPOImportReference_Table(_condList);
      }
    }
  }, [formState.invoicePORef_List]);
  const [cellState, setCellState] = useState("");
  // let condName = ""
  // let condRate = ""
  const handleGridChange = (data, operation, pr1, pr2, pr3, pr4) => {
    // let rowIndex = cellState?.cell?.row;
    let rowIndex = operation[0].fromRowIndex;

    let name = cellState?.cell?.colId;
    let tempArray = data;

    // for consumed quantity
    if (name === "amount") {
      //  let _tot = formState.invoicePORef_List.filter(i => i.vText === "").map(i => i.val_Loccur).reduce((x, y) => parseFloat(x) + parseFloat(y));
      let condName = tempArray[rowIndex].Condition_vText;
      let condRate = tempArray[rowIndex].amount;

      formState.invoicePORef_List.forEach(function (item) {
        if (item.vText == condName) {
          let _tot = formState.invoicePORef_List
            .filter((i) => i.vText === item.vText)
            .map((i) => i.val_Loccur)
            .reduce((x, y) => parseFloat(x) + parseFloat(y));

          // _tot = formState.invoicePORef_List
          //   .filter(
          //     (i) =>
          //       formState.invoicePORef_List
          //         .filter((i) => i.vText == item.vText)
          //         .map((a) => a.poItem)
          //         .includes(i.poItem) && i.vText == ""
          //   )
          //   .map((i) => i.val_Loccur)
          //   .reduce((x, y) => parseFloat(x) + parseFloat(y));

          // let material = formState.invoicePORef_List.filter(
          //   (i) => i.vText == "" && i.poItem == item.poItem
          // );
          let material = formState.invoicePORef_List.filter(
            (i) => i.vText == item.vText && i.poItem == item.poItem
          );
          if (material.length > 0 && condRate !== 0) {
            var mrate = material[0].val_Loccur;
            item.inpuT_QTY = Number(item.quantity);
            let InputValue = ((condRate / _tot) * mrate).toFixed(2);
            item.inpuT_VAL = Number(InputValue);
          } else if (condRate === 0 || !condRate) {
            item.inpuT_QTY = 0;
            item.inpuT_VAL = 0;
          }
        }
      });
    }
    setPOImportReference_Table([...tempArray]);
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: formState.invoicePORef_List,
    }));
  };

  const [columns, setColumns] = useState([
    {
      ...keyColumn("Condition_vText", textColumn),
      title: "Condition Name",
      minWidth: 200,
      disabled: true,
    },
    {
      ...keyColumn("amount", floatColumn),
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.amount = parseFloat(value.replace(/,/g, ""));
        return rowData;
      },
    
      minWidth: 110,

      title: "Amount",
      disabled:disabled
    },
  ]);
  return (
    <div>
      <Grid container style={{ margin: "20px 0px" }}>
        <Grid item xs={12} sm={12} md={6} lg={6} style={{ width: "0" }}>
          <Heading title="PO Reference Details" />

          {POImportReference_Table?.length === 0 && !loading ? (
            <EmptyData />
          ) : loading ? (
            <>
              <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
                <LinearProgress color="info" />
                <LinearProgress color="info" />
                <LinearProgress color="info" />
              </Stack>
            </>
          ) : (
            <DataSheetGrid
              style={{
                "--dsg-header-text-color": "#031C30",
              }}
              value={POImportReference_Table}
              onChange={handleGridChange}
              columns={columns}
              //  lockRows={(disabled || formState.invoicePORef_List.length === 0) ? true: false}
              lockRows={true}
              onActiveCellChange={(res) => {
                setCellState(res);
              }}

              // onDelete={handleDelete}
            />
          )}
          {/* {!disabled && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )} */}
        </Grid>
      </Grid>
    </div>
  );
}

export default React.memo(PoImportReference_Table);
